import React, { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import PasswordChangeModal from '../auth/PasswordChangeModal'

const Header = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [showPwd, setShowPwd] = useState(false)

  return (
    <header className="bg-gray-800 shadow-lg">
      <div className="flex items-center h-16">
        {/* Logo section - matches sidebar width */}
        <div className="w-64 flex items-center justify-center">
          <img
            src={`${import.meta.env.BASE_URL}Logo-Bertrin.png`}
            alt="Inmobiliaria Bertrin"
            className="h-10 w-auto"
          />
        </div>

        {/* User info section */}
        <div className="flex-1 flex items-center justify-end px-4 sm:px-6 lg:px-8">
          {user && (
            <div className="flex items-center space-x-3">
              {/* Change password button */}
              <button
                onClick={() => setShowPwd(true)}
                className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-200 hover:text-white rounded-lg transition-all duration-200 border border-gray-600 hover:border-gray-500"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                <span className="text-sm font-medium">Cambiar Contraseña</span>
              </button>

              {/* Logout button */}
              <button
                onClick={async () => { await logout(); navigate('/login'); }}
                className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                <span className="text-sm font-medium">Cerrar Sesión</span>
              </button>

              {/* User profile badge */}
              <div className="flex items-center bg-gradient-to-r from-gray-700 to-gray-800 px-5 py-2.5 border-l border-gray-600 shadow-md hover:shadow-lg transition-all duration-200 hover:border-gray-500">
                <div className="relative">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center ring-2 ring-gray-600 ring-offset-2 ring-offset-gray-700">
                    <span className="text-white text-sm font-bold tracking-wide">
                      {user.first_name?.[0]?.toUpperCase()}{user.last_name?.[0]?.toUpperCase()}
                    </span>
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-700"></div>
                </div>
                <div className="ml-3 flex flex-col">
                  <span className="text-sm text-white font-semibold leading-tight">
                    {user.first_name} {user.last_name}
                  </span>
                  <span className="text-xs text-gray-400 font-medium capitalize">
                    {user.role === 'admin' ? 'Administrador' : user.role === 'moderator' ? 'Moderador' : 'Usuario'}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <PasswordChangeModal isOpen={showPwd} onClose={() => setShowPwd(false)} />
    </header>
  )
}

export default Header
